'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _keyBy = require('lodash/keyBy');
var _intersection = require('lodash/intersection');
var _values = require('lodash/values');

var validateValue = require('./validate-value');

/**
 * Accepts a full or partial entity and validates it against the client fields
 * @param {object} entityRequest The updated entity properties to validate
 * @param {Array|object} clientFields The collection of client fields for the entity's type
 * @return {object} The result of the validation. The 'errors' object will be a collection of validation
 * results
 * {
 *   isValid: {boolean},
 *   errors: {object}
 * }
 */
module.exports = function validateEntityRequest(entityRequest, clientFields) {
  //Convert keyed field object to Array if given
  if (clientFields.constructor !== Array) {
    clientFields = _values(clientFields);
  }

  var validKeys = clientFields.map(function (f) {
    return f.objectKey;
  });
  var keysToValidate = _intersection(validKeys, Object.keys(entityRequest));
  var indexedFields = _keyBy(clientFields, function (f) {
    return f.objectKey;
  });

  var errors = keysToValidate.reduce(function (acc, fieldKey) {
    var field = indexedFields[fieldKey];
    var value = entityRequest[fieldKey];

    return [].concat(_toConsumableArray(acc), _toConsumableArray(validateValue(indexedFields, field.objectKey, field, value)));
  }, []);

  var isValid = errors.length === 0;

  return {
    isValid: isValid,
    errors: isValid ? null : errors
  };
};